export default __webpack_public_path__ + "static/media/flexline_logo_de.c36146a4.png";